import { useTracker } from '@/core/tracking';
import { useLocalization } from '@/services/localizationService';
import useTutorial from './useTutorial';

export default function Tutorial() {
  const {
    showPrevStep,
    showNextStep,
    tutorial,
    anchorPosition,
    resetTutorial,
    getTutorialStepLayoutPosition,
    getPinPosition,
  } = useTutorial();
  const { track } = useTracker();
  const { t, data } = useLocalization();

  return (
    <>
      <div className="absolute w-[100%] h-[100%] bg-overlay-black-60 z-20" />
      {tutorial.steps.length && (
        <div
          className="absolute bg-secondary-yellow text-black w-[231px] rounded-[16px] p-4 z-50"
          style={{
            top: `${anchorPosition?.top}px` || '0',
            left: `${anchorPosition?.left}px` || '0',
            transform: getTutorialStepLayoutPosition(
              tutorial.steps[tutorial.currentStep - 1].position
            ),
          }}
        >
          <span
            className={`absolute block w-0 h-0 ${getPinPosition(
              tutorial.steps[tutorial.currentStep - 1].position
            )}`}
          />

          <p className="text-[9px] font-bold opacity-40 mb-1">
            {tutorial.steps[tutorial.currentStep - 1].index}/
            {tutorial.steps.length}
          </p>
          <p className="text-[13px] font-medium leading-4">
            {t(tutorial.steps[tutorial.currentStep - 1].description)}
          </p>
          <div className="flex flex-row justify-between items-center mt-4">
            {tutorial.currentStep === 1 ? (
              <button
                type="button"
                className="text-[13px] leading-4 font-bold"
                onClick={() => {
                  track('tutorial', 'skipped', { tutorialId: tutorial.id });
                  resetTutorial();
                }}
              >
                {t(data.result.skipTutorial)}
              </button>
            ) : (
              <button
                type="button"
                className="text-[13px] leading-4 font-bold"
                onClick={() => {
                  const { shouldExecuteBeforePreviousStep } =
                    tutorial.steps[tutorial.currentStep - 1];
                  if (shouldExecuteBeforePreviousStep) {
                    shouldExecuteBeforePreviousStep();
                  }
                  showPrevStep(tutorial.currentStep);
                }}
              >
                {t(data.common.back)}
              </button>
            )}
            <button
              type="button"
              className="text-[13px] leading-4 font-bold btn--white btn py-2 px-3"
              onClick={() => {
                const { shouldExecuteBeforeNextStep } =
                  tutorial.steps[tutorial.currentStep - 1];
                if (shouldExecuteBeforeNextStep) {
                  shouldExecuteBeforeNextStep();
                }
                showNextStep(tutorial.currentStep);
              }}
            >
              {tutorial.steps.length === tutorial.currentStep
                ? t(data.common.end)
                : t(data.common.next)}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
